import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import share from "../../assets/img/icons/share.svg";
import tags_active from "../../assets/img/icons/tags_active.svg";
import { getDateFormat } from "../../utils";
import { removeFromReadingList } from "../../store/apiCalls/dashboard";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Dropdown, Menu, Button } from "antd"
import {
  LinkedinShareButton,
  TwitterShareButton,
  FacebookShareButton,
} from "react-share";
import open from "../../assets/img/icons/open.svg";
import copylink from "../../assets/img/icons/copylink.svg";
import linkedin_share from "../../assets/img/icons/linkedin_share.svg";
import twitter_share from "../../assets/img/icons/twitter_share.svg";
import facebook_share from "../../assets/img/icons/facebook_share.svg";
import mendeley from "../../assets/img/icons/mendeley.svg";
import { toast } from "react-toastify";
import { addArticleToReadingList } from "../../store/apiCalls/dashboard";
import tags from "../../assets/img/icons/tags.svg";
import copy from "copy-to-clipboard";
import { SERVER_URL } from "../../config";

const NewRelatedArticles = ({
  published,
  id,
  title,
  userTitle,
  issue,
  volume,
  userName,
  contentWithoutSpecialChars,
  typeOfArticle,
  journalName,
  reviewType,
  journalType,
  subjectName,
  specialization,
  fetchReadingList,
  articleId,
  slug,
  readingflag,
  pageName,
}) => {
  // console.log("issue", issue ,volume);
  const MAX_WORDS = 10;
  const MAX_TITLE_WORDS = 10;
  const SHARE_URL = `${SERVER_URL}/viewPublishedArticle/${articleId}`;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showDeleted, setShowDeleted] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [copied, setCopied] = useState("");
  const userDetails = useSelector((state) => state?.LoginReducer?.user);
  const token = localStorage.getItem("usertoken");

  const handleRemoveReadingList = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      id: id,
      isDeleted: true,
    };
    const response = await removeFromReadingList(headers, params);
    if (response?.status === 200) {
      dispatch({ type: "SET_LOADER", payload: false });
      fetchReadingList();
      setShowDeleted(false);
    } else {
      dispatch({ type: "SET_LOADER", payload: false });
      return toast.error("Please try again");
    }
  };
  const formatUrl = (inputString) => {
    if (!inputString) {
      return ""; // Return an empty string or handle the case appropriately
    }
    let formattedString = inputString.toLowerCase();
    formattedString = formattedString.replace(/\s/g, "-");
    return formattedString;
  };
  const handlejournalNameforurl = (journalType, typeOfArticle) => {
    var fname = "";
    if (journalType == "Mega Journal" && typeOfArticle == "Conference Papers") {
      fname = formatUrl("Conference Paper");
    } else {
      fname = formatUrl(journalType);
    }

    // setjournalNameforurl(fname);
    return fname;
  };
  const handlesubjectName = (para) => {
    const subjectMapping = {
      "Medicine and Health Sciences": "medicine",
      "Business, Management and Communication": "business-management",
      "Social Science and Humanities": "social-science",
      Science: "science",
      Engineering: "engineering",
      "Information Technology": "information-technology",
      Ayurveda: "ayurveda",
    };

    const fname = subjectMapping[para] || para;
    // console.log("subjectName", subjectName);
    // setsubjectNameforurl(fname);
    return formatUrl(fname);
  };
  const handleRedirect = (e, path) => {
    if (e !== "") e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };
  const handleClick = () => {
    handleRedirect(
      "",
      `/${handlejournalNameforurl(
        journalType,
        typeOfArticle
      )}/${handlesubjectName(subjectName)}/article/${slug}`
    );
  };
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  const copyToClipboard = (code) => {
    copy(code);
    return toast.success("Copied");
  };
  const handleMendeleyClick = () => {
    copy(SHARE_URL);
    window.open(
      "https://www.mendeley.com/reference-manager/library/all-references",
      "_blank"
    );
    addShareCount();
  };
  const addArticleToReadingLists = async () => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      articleId: articleId,
      userId: userDetails?._id,
    };
    const response = await addArticleToReadingList(headers, params);
    if (response?.status === 200) {
      fetchReadingList();
    } else {
      return toast.error("Please login to save the article.");
    }
  };
  // console.log("userName", contentWithoutSpecialChars);

  function formatName(name) {
    if (!name) return "";

    return name
      .trim()
      .split(/\s+/) // split by single or multiple spaces
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  const shareItems = [
    {
      key: "mendeley",
      label: (
        <div onClick={handleMendeleyClick} className="shareItem">
          <b><img src={mendeley} alt="#" /></b>
          Mendeley
        </div>
      ),
    },
    {
      key: "twitter",
      label: (
        <TwitterShareButton
          url={SHARE_URL}
          title={title}
          hashtag="vikramshila"
          className="shareItem"
        >
          <b><img src={twitter_share} alt="#" /></b>
          Twitter
        </TwitterShareButton>
      ),
    },
    {
      key: "facebook",
      label: (
        <FacebookShareButton
          url={SHARE_URL}
          title={title}
          hashtag="vikramshila"
          className="shareItem"
        >
          <b><img src={facebook_share} alt="#" /></b>
          Facebook
        </FacebookShareButton>
      ),
    },
    {
      key: "linkedin",
      label: (
        <LinkedinShareButton
          url={SHARE_URL}
          title={title}
          className="shareItem"
        >
          <b><img src={linkedin_share} alt="#" /></b>
          LinkedIn
        </LinkedinShareButton>
      ),
    },
    {
      key: "copylink",
      label: (
        <a onClick={() => copyToClipboard(SHARE_URL)} className="shareItem">
          <b><img src={copylink} alt="#" /></b>
          Copy Link
        </a>
      ),
    },
  ];

  return (
    <>
      <div
        className={
          pageName == "access-articles" || pageName == "all-articles"
            ? "recommendedBox newlook ml-0 mr-0 bgColorNone w-100 mb-4"
            : "recommendedBox newlook ml-0 mr-0 bgColorNone w-100"
        }
      // style={{ width: "1200px" }}
      >
        <div className="recommendedHead">
          <div
            className={
              pageName == "society-homepage"
                ? "d-flex flex-wrap left-part"
                : "d-flex gap-4 left-part"
            }
            style={pageName == "society-homepage" ? { gap: "5px 25px" } : {}}
          >
            {/* <span>
              <img src={open} className="pr-2" alt="#" />
              Open Access
            </span> */}
            <span>{typeOfArticle && <span>{typeOfArticle}</span>}</span>
            <span>Published: {getDateFormat(published)}</span>
            {journalType == "Mega Journal" ? (
              <>
                <span>
                  <b className="fw-medium  text-black">
                    <b className="fw-medium theme-orange-color">Vol:</b>{" "}
                    {volume ? volume : "1"}
                  </b>
                </span>
                <span>
                  <b className="fw-medium text-black">
                    <b className="fw-medium theme-orange-color">Issue:</b>{" "}
                    {issue ? issue : "1"}
                  </b>
                </span>
              </>
            ) : volume == "" ? (
              ""
            ) : (
              <>
                <span>
                  <b className="fw-medium  text-black">
                    <b className="fw-medium theme-orange-color">Vol:</b>{" "}
                    {volume ? volume : "1"}
                  </b>
                </span>
                <span>
                  <b className="fw-medium text-black">
                    <b className="fw-medium theme-orange-color">Issue:</b>{" "}
                    {issue ? issue : "1"}
                  </b>
                </span>
              </>
            )}

            {pageName != "access-articles" && (
              <>
                <span>
                  {subjectName == "Business, Management and Communication"
                    ? "Business and Management"
                    : subjectName}
                </span>
              </>
            )}
          </div>
          {/* <div className="recommendedShare">
            <i className="shareLogo">
              <img src={share} alt="#" />
              <div className="publisNav">
                <a onClick={handleMendeleyClick}>
                  <b>
                    <img src={mendeley} alt="#" />
                  </b>
                  Mendeley
                </a>
                <TwitterShareButton
                  url={SHARE_URL}
                  title={title}
                  hashtag={"vikramshila"}
                >
                  <a>
                    <b>
                      <img src={twitter_share} alt="#" />
                    </b>
                    Twitter
                  </a>
                </TwitterShareButton>
                <FacebookShareButton
                  url={SHARE_URL}
                  title={title}
                  hashtags={"vikramshila"}
                >
                  <a>
                    <b>
                      <img src={facebook_share} alt="#" />
                    </b>
                    Facebook
                  </a>
                </FacebookShareButton>
                <LinkedinShareButton url={SHARE_URL} title={title}>
                  <a>
                    <b>
                      <img src={linkedin_share} alt="#" />
                    </b>
                    LinkedIn
                  </a>
                </LinkedinShareButton>
                <a onClick={() => copyToClipboard(SHARE_URL)}>
                  <b>
                    <img src={copylink} alt="#" />
                  </b>
                  Copy Link
                </a>
              </div>
            </i>
            {pageName === "search" && token && (
              <i>
                <img
                  src={readingflag == true ? tags_active : tags}
                  onClick={() =>
                    readingflag == true
                      ? setShowDeleted(true)
                      : addArticleToReadingLists()
                  }
                />
              </i>
            )}
            {pageName === "search" && !token && (
              <i>
                <img
                  src={readingflag == true ? tags_active : tags}
                  onClick={() => navigate("/login")}
                  alt="#"
                />
              </i>
            )}
            {pageName !== "search" && (
              <i>
                <img
                  src={readingflag == true ? tags_active : tags}
                  onClick={() =>
                    readingflag == true
                      ? setShowDeleted(true)
                      : addArticleToReadingLists()
                  }
                />
              </i>
            )}
          </div> */}
        </div>
        <div className="recommendedTitle">
          {/* {title?.split(" ").length > MAX_WORDS ? (
            <h2
            className="py-2"
              onClick={() => handleClick(true)}
              dangerouslySetInnerHTML={{
                __html:
                  title?.split(" ")?.slice(0, MAX_TITLE_WORDS).join(" ") +
                  "....",
              }}
            ></h2>
          ) : (
            <h2
              className="py-2"
              onClick={() => handleClick(true)}
              dangerouslySetInnerHTML={{
                __html: title?.split(" ")?.slice(0, MAX_TITLE_WORDS).join(" "),
              }}
            ></h2>
          )} */}
          <h2
            className="py-2"
            onClick={() => handleClick(true)}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          ></h2>
          {/* <h3>{userTitle + " " + userName}</h3> */}


          <div style={{ display: "flex", flexDirection: "row", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
            <h3>
              {userName?.map((autName, index) => {
                return (
                  <>
                    {index == 0 ? "" : <>,&nbsp;</>}
                    {/* {autName.title + " " + autName.fullName} */}
                    {/* {autName?.fullName} */}
                    {formatName(autName.fullName)}
                    {/* {autName?.orcidId == "" ||
                      autName?.orcidId == undefined ||
                      autName?.orcidId == null ? null : (
                      <>
                        <a
                          target="_blank"
                          className="m-1"
                          href={`https://orcid.org/${autName?.orcidId}`}
                        >
                          <img src="http://www.aakashgangaopen.in/static/media/id.d81da1c9dab3ce3fa306.svg" />
                        </a>
                      </>
                    )} */}
                  </>
                );
              })}
            </h3>
            <div className="recommendedShare" style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
              <div className="shareWrapper">
                <Dropdown
                  menu={{ items: shareItems }}
                  trigger={["hover"]}                 // 👈 hover enabled
                  placement="bottomRight"
                  overlayClassName="publisNav"        // 👈 use your CSS
                >
                  <div className="shareLogo">
                    <img src={share} alt="#" />
                  </div>
                </Dropdown>
              </div>

              {pageName === "search" && token && (
                <i>
                  <img
                    src={readingflag == true ? tags_active : tags}
                    onClick={() =>
                      readingflag == true
                        ? setShowDeleted(true)
                        : addArticleToReadingLists()
                    }
                  />
                </i>
              )}
              {pageName === "search" && !token && (
                <i>
                  <img
                    src={readingflag == true ? tags_active : tags}
                    onClick={() => navigate("/login")}
                    alt="#"
                  />
                </i>
              )}

              {/* save */}
              {pageName !== "search" && (
                <i>
                  <img
                    src={readingflag == true ? tags_active : tags}
                    onClick={() =>
                      readingflag == true
                        ? setShowDeleted(true)
                        : addArticleToReadingLists()
                    }
                  />
                </i>
              )}
            </div>
          </div>


          {pageName == "access-articles" || pageName == "all-articles" ? (
            <>
              <div className="py-3">
                <p
                  className={isExpanded ? "" : "twolinelimit"}
                  dangerouslySetInnerHTML={{
                    __html: contentWithoutSpecialChars,
                  }}
                ></p>
              </div>
            </>
          ) : null}
          {pageName == "access-articles" || pageName == "all-articles" ? (
            <>
              <div className="py-3 row">
                <div className="col-md-6">
                  <p className="reviewtype">
                    {reviewType.replace(/\bonly\b/g, "")}
                  </p>
                </div>
                <div className="col-md-6">
                  <p
                    className="ms-auto me-0 d-block text-right readmorebtn"
                    onClick={toggleExpand}
                  >
                    {" "}
                    {isExpanded ? "Read less" : "Read more ..."}
                  </p>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
      <Modal
        dialogClassName="modal-dialog-centered modal-sm authorModal"
        show={showDeleted}
        id="congratsMobile"
        tabIndex={-1}
        className="authorModal md-x"
      >
        <Modal.Header className="modal-header">
          <div class="modal-icon"> </div>
          <h2 class="modal-title">Confirmation</h2>
          <button
            type="button"
            class="btn-close"
            ariaLabel="Close"
            onClick={() => setShowDeleted(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="allGoodText01">
            <p>
              Are you sure you want to remove this article from the reading
              list?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <span
            class="btn-link-gray bold mr-3"
            onClick={() => handleRemoveReadingList()}
          >
            CONFIRM
          </span>
          <button
            className="button button-primary"
            type="button"
            onClick={(e) => {
              pageName === "search"
                ? setShowDeleted(false)
                : (setShowDeleted(false), window.history.back());
            }}
          >
            No, GO BACK
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default NewRelatedArticles;
